// 个人主页
export default {
  routes: [
    {
      path: '/profilePage',
      name: 'profilePage',
      meta: {
        title: '个人主页',
        pageId: 'F1303',
        level: 2,
        isAutoPV: false
      },
      component: () =>
        import(/* webpackChunkName: "profilePage" */ '../views/profilePage/index.vue')
    }
  ]
}
